import { API_URL } from 'constants/envConstants';

export enum UNIFIED_MODEL_NAMES {
  BOMS = 'boms',
  ACCESS_ROLES = 'access_roles',
  ACCESS_ROLE_LINES = 'access_role_lines',
  ACCESS_ROLE_ASSIGNMENTS = 'access_role_assignments',
}
const API_URL_UNIFIED = `${API_URL}/unified`;

interface UnifiedUrls {
  BOMS: (query?: string) => string;
  ACCESS_ROLES: (query?: string) => string;
  ACCESS_ROLE_LINES: (query?: string) => string;
  ACCESS_ROLE_ASSIGNMENTS: (query?: string) => string;
  TOGGLE_APPROVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNAPPROVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_ARCHIVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNARCHIVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_LOCK: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNLOCK: (modelName: UNIFIED_MODEL_NAMES) => string;
}

export const UNIFIED_URLS: UnifiedUrls = {
  BOMS: (query = '') =>
    `${API_URL_UNIFIED}/${UNIFIED_MODEL_NAMES.BOMS}/${query}`,
  ACCESS_ROLES: (query = '') =>
    `${API_URL_UNIFIED}/${UNIFIED_MODEL_NAMES.ACCESS_ROLES}/${query}`,
  ACCESS_ROLE_LINES: (query = '') =>
    `${API_URL_UNIFIED}/${UNIFIED_MODEL_NAMES.ACCESS_ROLE_LINES}/${query}`,
  ACCESS_ROLE_ASSIGNMENTS: (query = '') =>
    `${API_URL_UNIFIED}/${UNIFIED_MODEL_NAMES.ACCESS_ROLE_ASSIGNMENTS}/${query}`,
  TOGGLE_APPROVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/approve/`,
  TOGGLE_UNAPPROVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unapprove/`,
  TOGGLE_ARCHIVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/archive/`,
  TOGGLE_UNARCHIVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unarchive/`,
  TOGGLE_LOCK: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/lock/`,
  TOGGLE_UNLOCK: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unlock/`,
};
